import { makeAutoObservable } from 'mobx';

class ConfirmAction {
  public confirmOpen: boolean = false;
  public title: string = '';
  public message: string = '';

  constructor() {
    makeAutoObservable(this);
  }

  public setConfirmOpen = (open: boolean) => {
    this.confirmOpen = open;
  };

  public setTitle = (title: string) => {
    this.title = title;
  };

  public setMessage = (message: string) => {
    this.message = message;
  };
}

export default ConfirmAction;
